(function () {
  const RESULTS = {
    alarm: {
      title: 'Des signes justifient une vérification rapprochée',
      summary:
        'Une odeur inhabituelle, une base molle ou des racines très dégradées ne permettent pas de conclure à distance, mais rendent une inspection pertinente.',
      checks: [
        'Isolez la plante si vous suspectez aussi des ravageurs.',
        'Observez le collet et les racines accessibles : fermeté, couleur, odeur et détachement des tissus.',
        'Photographiez l’état initial avant toute intervention, notamment si la plante vient d’être livrée.'
      ],
      action:
        'N’ajoutez ni eau ni engrais par réflexe. Si la plante vient de Plant x Me, contactez-nous avec des photos nettes avant une intervention importante.',
      caution:
        'Évitez le rempotage systématique ou la coupe massive de racines sans avoir confirmé la présence de tissus réellement dégradés.'
    },
    wet: {
      title: 'Une zone racinaire trop humide est une hypothèse à vérifier',
      summary:
        'Le jaunissement associé à un substrat durablement humide peut correspondre à un manque d’oxygène racinaire, mais aussi à une acclimatation ou au vieillissement d’une feuille.',
      checks: [
        'Comparez l’humidité en profondeur et en surface ; la surface seule peut être trompeuse.',
        'Vérifiez que le pot s’égoutte et qu’il ne reste pas dans une soucoupe pleine.',
        'Surveillez l’évolution du collet, l’odeur et la fermeté des racines accessibles.'
      ],
      action:
        'Laissez le substrat revenir vers son niveau d’humidité habituel, gardez lumière et température stables, puis réévaluez sous 48 à 72 heures.',
      caution:
        'N’essayez pas de “compenser” avec de l’engrais et ne rempotez pas seulement parce qu’une feuille ancienne jaunit.'
    },
    dry: {
      title: 'Un manque d’eau est possible, mais doit être confirmé',
      summary:
        'Un substrat sec peut expliquer une perte de turgescence ou accélérer le jaunissement. Le poids du pot et l’humidité en profondeur donnent une information plus fiable qu’un calendrier.',
      checks: [
        'Soupesez le pot et vérifiez l’humidité à plusieurs centimètres de profondeur.',
        'Regardez si le substrat s’est rétracté et si l’eau risque de longer les parois sans humidifier la motte.',
        'Vérifiez que la plante n’a pas été exposée brutalement à davantage de lumière ou de chaleur.'
      ],
      action:
        'Si toute la motte est réellement sèche, arrosez lentement et complètement, laissez égoutter, puis observez la réaction de la plante.',
      caution:
        'Une plante molle dans un substrat humide n’a pas forcément soif : rajouter de l’eau pourrait aggraver un problème racinaire.'
    },
    acclimation: {
      title: 'Une acclimatation ou une sénescence naturelle est plausible',
      summary:
        'Après un transport ou un changement d’environnement, la perte d’une feuille ancienne peut être une réponse transitoire. Ce n’est pas une preuve de maladie.',
      checks: [
        'Confirmez que le jaunissement reste limité à une feuille ancienne.',
        'Vérifiez que le collet est ferme et qu’aucune odeur inhabituelle n’est présente.',
        'Observez si une nouvelle pousse reste active et si le phénomène se stabilise.'
      ],
      action:
        'Installez la plante dans des conditions stables, avec une lumière adaptée mais sans changement brutal, et observez-la pendant quelques jours.',
      caution:
        'Multiplier immédiatement les changements — rempotage, engrais, déplacement et traitement — rend la réaction de la plante plus difficile à comprendre.'
    },
    broad: {
      title: 'Le symptôme demande une observation plus large',
      summary:
        'Plusieurs feuilles touchées ou une jeune feuille atteinte orientent vers un facteur encore actif : racines, lumière, nutrition, ravageurs ou conditions environnementales.',
      checks: [
        'Examinez les deux faces des feuilles et les pétioles à la recherche de ravageurs.',
        'Reconstituez les changements des deux dernières semaines : arrosage, lumière, température, engrais et rempotage.',
        'Comparez la nouvelle croissance à la précédente et contrôlez l’état racinaire si d’autres signes l’indiquent.'
      ],
      action:
        'Stabilisez les conditions, documentez les symptômes et cherchez le facteur commun avant de choisir une intervention.',
      caution:
        'Une feuille jaune ne suffit pas à identifier une carence. Ajouter un nutriment sans vérifier le pH, les racines et la fertilisation récente peut brouiller le diagnostic.'
    },
    observe: {
      title: 'Aucun signal unique ne permet encore de conclure',
      summary:
        'Le jaunissement est un symptôme général. L’évolution dans le temps et l’apparition éventuelle de nouveaux signes seront plus informatives qu’une action immédiate.',
      checks: [
        'Prenez une photo datée et notez la feuille concernée.',
        'Contrôlez l’humidité réelle du substrat et la stabilité de l’emplacement.',
        'Réévaluez la plante sous 48 à 72 heures ou plus tôt si elle se dégrade rapidement.'
      ],
      action:
        'Conservez des conditions cohérentes et intervenez seulement lorsqu’une hypothèse est soutenue par plusieurs observations.',
      caution:
        'Évitez d’enchaîner plusieurs corrections simultanées : vous ne saurez plus laquelle était utile ou nuisible.'
    }
  };

  function chooseResult(values) {
    if (values.alarm === 'yes') return RESULTS.alarm;
    if (values.moisture === 'wet') return RESULTS.wet;
    if (values.moisture === 'dry') return RESULTS.dry;
    if (values.arrival === 'yes' && values.leaves === 'old') return RESULTS.acclimation;
    if (values.leaves === 'new' || values.leaves === 'multiple') return RESULTS.broad;
    return RESULTS.observe;
  }

  function renderResult(container, result) {
    const items = result.checks.map((item) => `<li>${item}</li>`).join('');
    container.innerHTML = `
      <p class="pxm-space__kicker">Piste de réflexion</p>
      <h3>${result.title}</h3>
      <p>${result.summary}</p>
      <h4>Ce qu’il faut vérifier</h4>
      <ul>${items}</ul>
      <h4>Action prudente maintenant</h4>
      <p>${result.action}</p>
      <p class="pxm-result__caution"><strong>À éviter :</strong> ${result.caution}</p>
    `;
    container.hidden = false;
    container.setAttribute('tabindex', '-1');
    container.focus({ preventScroll: true });
    container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function initDiagnostic(root) {
    if (!root || root.dataset.pxmReady === 'true') return;
    root.dataset.pxmReady = 'true';

    const form = root.querySelector('[data-pxm-diagnostic-form]');
    const result = root.querySelector('[data-pxm-result]');
    const error = root.querySelector('[data-pxm-error]');
    const nodes = Array.from(root.querySelectorAll('[data-pxm-map-node]'));
    const progress = root.querySelector('[data-pxm-map-progress]');
    const submit = root.querySelector('[data-pxm-map-submit]');
    const previewTitle = root.querySelector('[data-pxm-map-result-title]');
    const reset = root.querySelector('[data-pxm-map-reset]');
    if (!form || !result || !error) return;

    function valuesFromForm() {
      const data = new FormData(form);
      return {
        arrival: data.get('arrival'),
        moisture: data.get('moisture'),
        leaves: data.get('leaves'),
        alarm: data.get('alarm')
      };
    }

    function syncMap() {
      const values = valuesFromForm();
      const completed = Object.values(values).filter(Boolean).length;
      nodes.forEach((node) => {
        const checked = node.querySelector('input:checked');
        node.classList.toggle('is-complete', Boolean(checked));
      });
      if (progress) progress.textContent = `${completed} / 4 branches renseignées`;
      if (submit) submit.disabled = completed !== 4;
      if (previewTitle) {
        previewTitle.textContent = completed === 4 ? chooseResult(values).title : 'Complétez les quatre branches';
      }
      error.hidden = true;
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const values = valuesFromForm();

      if (Object.values(values).some((value) => !value)) {
        error.hidden = false;
        error.focus();
        return;
      }

      error.hidden = true;
      renderResult(result, chooseResult(values));
    });

    form.addEventListener('change', syncMap);
    function resetMap() {
      form.reset();
      error.hidden = true;
      result.hidden = true;
      result.innerHTML = '';
      syncMap();
    }
    if (reset) reset.addEventListener('click', resetMap);
    syncMap();
  }

  function initJourney(root) {
    if (!root || root.dataset.pxmJourneyReady === 'true') return;
    root.dataset.pxmJourneyReady = 'true';
    const viewport = root.querySelector('[data-pxm-journey-viewport]');
    const steps = Array.from(root.querySelectorAll('[data-pxm-journey-step]'));
    const previous = root.querySelector('[data-pxm-journey-prev]');
    const next = root.querySelector('[data-pxm-journey-next]');
    const count = root.querySelector('[data-pxm-journey-count]');
    if (!viewport || !steps.length) return;

    function currentIndex() {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let nearest = 0;
      let distance = Infinity;
      steps.forEach((step, index) => {
        const stepCenter = step.offsetLeft + step.offsetWidth / 2;
        const delta = Math.abs(stepCenter - center);
        if (delta < distance) { distance = delta; nearest = index; }
      });
      return nearest;
    }
    function update() {
      const index = currentIndex();
      if (count) count.textContent = `${index + 1} / ${steps.length}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === steps.length - 1;
    }
    function go(delta) {
      const index = Math.max(0, Math.min(steps.length - 1, currentIndex() + delta));
      steps[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    if (previous) previous.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    let frame;
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initLibrary(root) {
    if (!root || root.dataset.pxmLibraryReady === 'true') return;
    root.dataset.pxmLibraryReady = 'true';
    const filters = Array.from(root.querySelectorAll('[data-pxm-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-pxm-guide-card]'));
    const empty = root.querySelector('[data-pxm-library-empty]');
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const category = button.dataset.pxmFilter;
        filters.forEach((item) => item.classList.toggle('is-active', item === button));
        let visible = 0;
        cards.forEach((card) => {
          const show = category === 'all' || card.dataset.category === category;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pxm-diagnostic]').forEach(initDiagnostic);
    (scope || document).querySelectorAll('[data-pxm-wishlist]').forEach(initWishlist);
    (scope || document).querySelectorAll('[data-pxm-journey]').forEach(initJourney);
    (scope || document).querySelectorAll('[data-pxm-library]').forEach(initLibrary);
    initReveals(scope || document);
  }

  function initReveals(scope) {
    const root = scope || document;
    const selectors = [
      '[data-pxm-reveal]',
      '.pxm-page-hero',
      '.pxm-timeline__item',
      '.pxm-guide-chapter',
      '.pxm-variety-group',
      '.pxm-next-step'
    ];
    const elements = Array.from(root.querySelectorAll(selectors.join(','))).filter(
      (element) => element.dataset.pxmRevealReady !== 'true'
    );
    if (!elements.length) return;

    elements.forEach((element) => {
      element.dataset.pxmReveal = '';
      element.dataset.pxmRevealReady = 'true';
    });

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((element) => element.classList.add('pxm-is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('pxm-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px' }
    );
    elements.forEach((element) => observer.observe(element));
  }

  function initWishlist(root) {
    if (!root || root.dataset.pxmWishlistReady === 'true') return;
    root.dataset.pxmWishlistReady = 'true';

    const form = root.querySelector('.pxm-wishlist-form');
    const choices = Array.from(root.querySelectorAll('[data-pxm-wishlist-choice]'));
    const formats = Array.from(root.querySelectorAll('[data-pxm-format-choice]'));
    const valueField = root.querySelector('[data-pxm-wishlist-value]');
    const formatField = root.querySelector('[data-pxm-format-value]');
    const count = root.querySelector('[data-pxm-selection-count]');
    const error = root.querySelector('[data-pxm-wishlist-error]');
    const other = root.querySelector('[name="contact[Autre variété]"]');
    if (!form || !valueField || !formatField) return;

    function sync() {
      const selected = choices.filter((input) => input.checked).map((input) => input.value);
      const selectedFormats = formats.filter((input) => input.checked).map((input) => input.value);
      valueField.value = selected.join(', ');
      formatField.value = selectedFormats.join(', ');
      if (count) count.textContent = `${selected.length} variété${selected.length > 1 ? 's' : ''} sélectionnée${selected.length > 1 ? 's' : ''}`;
      if (error && (selected.length || (other && other.value.trim()))) error.hidden = true;
    }

    choices.forEach((input) => input.addEventListener('change', sync));
    formats.forEach((input) => input.addEventListener('change', sync));
    if (other) other.addEventListener('input', sync);
    form.addEventListener('submit', (event) => {
      sync();
      if (!valueField.value && !(other && other.value.trim())) {
        event.preventDefault();
        if (error) {
          error.hidden = false;
          error.focus();
        }
      }
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
